import React from 'react'
import css from '../css/profile-card.module.css';
import {Typography} from '@mui/material';
import { useSelector } from 'react-redux';

const ProfileCard = () => {
  const users = useSelector((store:any) => store.user);
  
  const username = `${users.FirstName}`; 
  const abbr = `${username?.at(0)} ${username.at(-1)}`

  return (
    <Typography className={css.container} sx={{paddingTop:"15px",paddingLeft:"10px"}} component={"div"}>
        <div>
            <span>{abbr.toUpperCase()}</span>
        </div>
        <Typography component={"div"}>
            <h3>{}</h3>
            <div>Admin</div>
        </Typography>
    </Typography>
  )
}

export default ProfileCard